import { BackgroundColor } from '@/theme/types';
import { cn } from '@/shadcn-ui/utils';
import { FlexcarColors } from '@/theme/colors';
import { withPageContainerStyles } from '@/common/components/page-layout';
import ChooseYourCarIcon from '@/icons/choose-your-car';
import DriveIcon from '@/icons/drive';
import Spacer from '@/common/components/spacer';
import UnlockIcon from '@/icons/unlock';

export const howItWorks = [
  {
    title: 'Choose',
    text: 'Choose from a range of makes and models. Insurance and maintenance included in one affordable payment.',
    icon: <ChooseYourCarIcon />,
  },
  {
    title: 'Meet',
    text: "Whether it's pick up or delivery, grab your keys and get familiar with your Flexcar. Our Member Concierge is there to handle any questions.",
    icon: <UnlockIcon />,
  },
  {
    title: 'Drive',
    text: 'Enjoy your Flexcar on your terms. Change plans, swap vehicles, or cancel anytime.',
    icon: <DriveIcon />,
  },
];

type TextColor = `text-flexcar-${FlexcarColors}`;

interface HowItWorksProps {
  className?: string;
  backgroundColor?: BackgroundColor;
  textColor?: TextColor;
}

export default function HowItWorks({
  backgroundColor = 'bg-flexcar-neutral90',
  textColor = 'text-flexcar-blue20',
  className,
}: HowItWorksProps) {
  return (
    <div
      className={cn(
        'flex w-full items-center justify-center py-20',
        backgroundColor,
        className
      )}
    >
      <div className={withPageContainerStyles('max-w-[1440px]')}>
        <div className="flex flex-col items-center justify-center">
          <p className={cn('body-strong', textColor)}>
            Put yourself in the driver&apos;s seat.
          </p>
          <Spacer variant="height16" />
          <h1 className={textColor}>How it works</h1>
        </div>

        <Spacer variant="height40" />

        <div className="flex flex-col justify-between gap-10 lg:flex-row">
          {howItWorks.map((step, i) => (
            <div key={i} className="flex flex-1 gap-6 lg:flex-col">
              <div className="w-[64px] flex-shrink-0">{step.icon}</div>
              <div className="flex flex-col gap-4">
                <h3 className={textColor}>{step.title}</h3>
                <p className={textColor}>{step.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
